// frontend/src/router/ProtectedRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useWeb3 } from "../context/Web3Context";

const ADMIN_WALLET = (process.env.REACT_APP_ADMIN_WALLET || "").toLowerCase();

/**
 * ✅ ProtectedRoute :
 * - Si requireWallet = true → page accessible à tout utilisateur connecté
 * - Si admin = true → seulement pour le wallet admin
 */
export default function ProtectedRoute({
  children,
  admin = false,
  requireWallet = false,
}) {
  const { isConnected, account } = useWeb3() || {};
  const location = useLocation();

  // 1️⃣ Redirige si pas connecté
  if (requireWallet && (!isConnected || !account)) {
    return (
      <Navigate
        to="/"
        replace
        state={{ from: location, reason: "wallet_not_connected" }}
      />
    );
  }

  // 2️⃣ Si c’est une route admin, vérifier le wallet
  if (admin && account?.toLowerCase() !== ADMIN_WALLET) {
    return (
      <Navigate
        to="/dashboard"
        replace
        state={{ from: location, reason: "not_admin" }}
      />
    );
  }

  // ✅ OK → accès autorisé
  return children;
}

/**
 * 👑 AdminRoute : réservé à l’administrateur
 */
export function AdminRoute({ children }) {
  return <ProtectedRoute admin requireWallet>{children}</ProtectedRoute>;
}
